import React from 'react'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import mainContext from '../contexts/mainContext';
export default function Sorting({ type }) {
    const { filterState, setFilterState } = React.useContext(mainContext);
    const handleSorting = () => {
        switch (type) {
            case "sByName":
                setFilterState({ ...filterState, sByName: filterState && filterState.sByName === -1 ? 1 : -1, sByEmail: null, sByRating: null, sByPosted: null })
                break;
            case "sByEmail":
                setFilterState({ ...filterState, sByEmail: filterState && filterState.sByEmail === -1 ? 1 : -1,sByName: null, sByRating: null, sByPosted: null })
                break;
            case "sByRating":
                setFilterState({ ...filterState, sByRating: filterState && filterState.sByRating === -1 ? 1 : -1,sByEmail: null, sByName: null, sByPosted: null })
                break;
            case "sByPosted":
                setFilterState({ ...filterState, sByPosted: filterState && filterState.sByPosted === -1 ? 1 : -1,sByEmail: null, sByRating: null, sByName: null })
                break;
        }

    }
    return (
        <>
            {
                filterState && filterState[type] === 1 ?
                    <ArrowUpwardIcon style={{fontSize:"20px"}} className='pointer' onClick={() => handleSorting(type)} /> :
                    <ArrowDownwardIcon style={{fontSize:"20px"}}  className='pointer' onClick={() => handleSorting(type)} />
            }
        </>
    )
}
